import React from "react";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import type { AuditLogSource } from "../types";

/**
 * Color spec for the `source` column. Sources come from a small fixed
 * vocabulary (4 values), so a single static map is enough — no need to
 * derive from semantic tokens or expose configuration.
 */
const SOURCE_STYLE: Record<AuditLogSource, { bg: string; text: string; label: string }> = {
  dashboard: { bg: "bg-sky-100",    text: "text-sky-800",    label: "Dashboard" },
  pipeline:  { bg: "bg-amber-100",  text: "text-amber-800",  label: "Pipeline" },
  admin:     { bg: "bg-rose-100",   text: "text-rose-800",   label: "Admin" },
  system:    { bg: "bg-slate-200",  text: "text-slate-700",  label: "System" },
};

const FALLBACK_STYLE = {
  bg: "bg-gray-100",
  text: "text-gray-700",
  label: "Unknown",
};

interface SourceChipProps {
  source: AuditLogSource | string;
  size?: "small" | "medium";
}

export const SourceChip: React.FC<SourceChipProps> = ({
  source,
  size = "small",
}) => {
  const style =
    (SOURCE_STYLE as Record<string, typeof FALLBACK_STYLE>)[source] ??
    { ...FALLBACK_STYLE, label: String(source) };

  return (
    <GenericTag
      label={style.label}
      variant="custom"
      backgroundColor={style.bg}
      textColor={style.text}
      size={size}
      rounded="full"
    />
  );
};

export default SourceChip;
